import '../../common_screen/my_result_contest_list/index.css';
import { View } from '../../../component';
import { getMatchStatus } from '../../../utilities/helper';
import { YNContestResultCard } from '../../component';
import React from 'react';
import DefaultContainer from '../../../container/default_container';

const MyContestListWeb = ({
  onPressCard,
  teamA,
  teamB,
  verified,
  challenges,
  matchTeamScore,
  status
}: any) => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="my-contest-list-wrapper">
        <View className="my-contest-list-primary-container">
          <div className="my-contest-list-header">
            <p>{`${teamA?.shortName} vs ${teamB?.shortName}`}</p>
            {''}
            <p style={{ paddingLeft: '10px' }}>{getMatchStatus(status, verified)}</p>
          </div>
          <div className="my-contest-list-card-wrapper">
            {challenges.map((item: any, idx: any) => (
              <div
                key={idx}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <YNContestResultCard
                  contest={item}
                  onPressCard={() => onPressCard(item, true)}
                  matchVerifiedStatus={verified}
                  matchTeamScore={matchTeamScore}
                />
              </div>
            ))}
          </div>
        </View>
      </div>
    </DefaultContainer>
  );
};

export default React.memo(MyContestListWeb);
